module.exports = __webpack_public_path__ + "media/images/about-pointimg03-cf1e9bf69b2a16a7f11a9ec1ba73a23b.png";